import React, { useEffect, useRef } from "react";
import Quagga from "quagga";

const BarcodeScanner = ({ setData, handleClose, closeOnScan = true }) => {
  const scannerRef = useRef(null);

  const onScan = (data) => {
    if (data) {
      setData(data);
      if (closeOnScan && typeof handleClose === "function") {
        handleClose();
      }
    }
  };

  useEffect(() => {
    if (!scannerRef.current) return;

    Quagga.init(
      {
        inputStream: {
          type: "LiveStream",
          target: scannerRef.current,
          constraints: {
            facingMode: "environment",
          },
        },
        decoder: {
          readers: ["code_128_reader", "ean_reader"],
        },
      },
      (err) => {
        if (err) {
          console.error(err);
          return;
        }
        Quagga.start();

        // Ensure inserted <video> and <canvas> fill and cover the container
        const video = scannerRef.current.querySelector("video");
        const canvas = scannerRef.current.querySelector("canvas");
        [video, canvas].forEach((el) => {
          if (el) {
            el.style.position = "absolute";
            el.style.top = "0";
            el.style.left = "0";
            el.style.width = "100%";
            el.style.height = "100%";
            el.style.objectFit = "cover";
          }
        });
      }
    );

    Quagga.onDetected((data) => {
      onScan(data.codeResult.code);
    });

    return () => {
      Quagga.stop();
    };
  }, []);

  const scannerWrapStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "240px",
    height: "160px",
    transform: "translate(-50%, -50%)",
    pointerEvents: "none",
    zIndex: 2,
  };

  const cornerStyle = {
    display: "block",
    width: "36px",
    height: "36px",
    position: "absolute",
    borderTop: "2px solid #3B82F6",
    borderRight: "2px solid #3B82F6",
  };

  const beforeStyle = {
    ...cornerStyle,
    right: "-14px",
    transform: "rotate(90deg)",
    bottom: "-14px",
  };

  const afterStyle = {
    ...cornerStyle,
    top: "-14px",
    right: "-14px",
  };

  const spanBeforeStyle = {
    ...cornerStyle,
    bottom: "-14px",
    left: "-14px",
    transform: "rotate(180deg)",
  };

  const spanAfterStyle = {
    ...cornerStyle,
    top: "-14px",
    left: "-14px",
    transform: "rotate(-90deg)",
  };

  return (
    <div
      ref={scannerRef}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        backgroundColor: "var(--color-ui-text)",
      }}
    >
      {/* Viewfinder corners */}
      <div style={scannerWrapStyle}>
        <div style={beforeStyle}></div>
        <div style={afterStyle}></div>
        <span>
          <div style={spanBeforeStyle}></div>
          <div style={spanAfterStyle}></div>
        </span>
      </div>
    </div>
  );
};

export default BarcodeScanner;
